// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectionList__QopvC4Opzs{max-height:400px;overflow-y:auto}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/settings/views/preferences/views/preferencesSummariesForm/preferencesSummariesForm.module.scss"],"names":[],"mappings":"AAEA,2BACE,gBAAA,CACA,eAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/dist/scss';\n\n.selectionList {\n  max-height: 400px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectionList": `selectionList__QopvC4Opzs`
};
export default ___CSS_LOADER_EXPORT___;
